import { Component, OnInit } from '@angular/core';
import { StepIndicatorModel, BreadCrumbService, StepIndicatorService } from 'lib/ng2-sapmp/src/ui-components';
import { STEPINDICATORS } from 'config';

@Component({
  selector: 'app-signup-fiveg',
  templateUrl: './signup-fiveg.component.html',
  styleUrls: ['./signup-fiveg.component.scss'],
  providers: [StepIndicatorService]
})
export class SignupFivegComponent implements OnInit {

  stepIndicators: StepIndicatorModel[];
  displayFlag: boolean;
  currentStep: any;
  sessionName: string;


  constructor(private breadCrumbService: BreadCrumbService, private stepIndicatorService: StepIndicatorService) {
    sessionStorage.removeItem('steps-fiveGEnrollment');
    sessionStorage.removeItem('newFivegEnrollment');
      // sessionStorage.removeItem('uploadedFile');
   }

  ngOnInit() {
    this.breadCrumbService.setCurrentBreadCrumb({ label: 'Device Enrollment', routerLink: '/5g/enrollment' });
    this.sessionName = 'fiveGEnrollment';
    this.stepIndicators = STEPINDICATORS.fiveGEnrollment;
    if (this.stepIndicatorService.getSteps(this.sessionName) === null) {
      this.stepIndicatorService.setSteps(this.stepIndicators, this.sessionName);
    }
    this.stepIndicators = this.stepIndicatorService.getSteps(this.sessionName);
    this.stepIndicatorService.getVisibility().subscribe(
      (status: boolean) => {
        this.displayFlag = status;
      }
    );

    this.stepIndicatorService.getCurrentStep().subscribe(
      (path: string) => {
        this.currentStep = path +' step';
      });
  }

}
